import React from 'react';
import './Our_Customers.css';

const customers = [
  "Shri Shirdi Devsthan Trust",
  "Tulja Bhavani Devsthan Trust, Tuljapur",
  "Vijay Gramin Prashant (20 Branches)",
  "Aarambh Gold Finance",
  "Ajit Jewellers",
  "Corporate Sector",
  "Jewellery Shops",
  "Builders",
  "Finance Cooperative Companies",
  "Bank of India",
  "Pandharpur Urban Cooperative Bank, Pandharpur",
  "Mandeshi Cooperative Bank",
  "Maloji Raje Sahkari Bank",
  "Maharaja Multi State Cooperative Bank",
  "Satara District Cooperative Bank"
];

const Our_Customers = () => {
  return (
    <section className="our-customers">
      <div className="container">
        <h2 className="title">Our Valued Customers</h2>
        
        <ul className="customer-list">
          {customers.map((customer, index) => (
            <li key={index} className="customer-item">
              {index + 1}. {customer}
            </li>
          ))}
        </ul>

          <div className='vdo_secion'></div>  

      </div>
    </section>
  );
};

export default Our_Customers;
